module.exports = __webpack_public_path__ + "img/team-1.6ea5c8d0.jpg";